import { createSlice } from "@reduxjs/toolkit";
import { getAllPlans, getSubscriptionHistory } from "./_pricingAction";


interface ManagePricingState {
  planList: any[];
  loading: boolean;
  error: string | null;
  historyList: any[];
  totalCount: number
}

const initialState: ManagePricingState = {
  planList: [],
  loading: false,
  error: null,
  historyList: [],
  totalCount: 0
};


export const pricingReducer = createSlice({
  name: "pricing",
  initialState: initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Pricing List
      .addCase(getAllPlans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.planList = action.payload?.data;
      })
      .addCase(getAllPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Fetch History List
      .addCase(getSubscriptionHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSubscriptionHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.historyList = action.payload?.data?.transactions;
        state.totalCount = action.payload?.count;
      })
      .addCase(getSubscriptionHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
  },
});


export const { clearError } = pricingReducer.actions;
export default pricingReducer;